import Flickity from "flickity"
import "flickity-imagesloaded"

export default class Home {
    constructor(element) {
        this.home = element

        this.ambassadorsCarousel = this.home.querySelector('.home-ambassadors-cards')
        if (this.ambassadorsCarousel) {
            this.initAmbassadorsCarousel();
        }

        this.instagramFeedCarousel = this.home.querySelector('.home-instagram-feed-carousel')
        if (this.instagramFeedCarousel) {
            this.initInstagramFeedCarousel();
        }

        this.blogCarousel = this.home.querySelector('.home-blog-carousel')
        if (this.blogCarousel) {
            this.initBlogCarousel();
        }
    }

    initAmbassadorsCarousel() {
        const ambassadorsPrevButton = this.home.querySelector('.home-ambassadors-content-control-previous')
        const ambassadorsNextButton = this.home.querySelector('.home-ambassadors-content-control-next')
        let carousel = new Flickity(this.ambassadorsCarousel, {
            pageDots: false,
            prevNextButtons: false,
            cellAlign: 'left',
            imagesLoaded: true,
        })

        this.initPrevNextButtons(
            carousel,
            ambassadorsPrevButton,
            ambassadorsNextButton
        )
    }

    initBlogCarousel() {
        const blogPrevButton = this.home.querySelector('.home-blog-header-control-previous')
        const blogNextButton = this.home.querySelector('.home-blog-header-control-next')
        let carousel = new Flickity(this.blogCarousel, {
            pageDots: false,
            prevNextButtons: false,
            cellAlign: 'left',
            imagesLoaded: true,
        })

        this.initPrevNextButtons(
            carousel,
            blogPrevButton,
            blogNextButton
        )
    }

    initInstagramFeedCarousel() {
        const instagramFeedPrevButton = this.home.querySelector('.home-instagram-feed-content-control-previous')
        const instagramFeedNextButton = this.home.querySelector('.home-instagram-feed-content-control-next')
        instagramFeedPrevButton.addEventListener('click', () => {
            this.instagramFeedCarousel.querySelector('.sbi-owl-prev').click()
        })

        instagramFeedNextButton.addEventListener('click', () => {
            this.instagramFeedCarousel.querySelector('.sbi-owl-next').click()
        })
    }

    initPrevNextButtons(carousel, prevButton, nextButton) {
        prevButton.addEventListener('click', function () {
            carousel.previous(true)
        })

        nextButton.addEventListener('click', function () {
            carousel.next(true)
        })
    }
}